var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9994 19.833C13.7016 19.8315 13.4078 19.7637 13.1394 19.6346C12.871 19.5054 12.6348 19.3182 12.4477 19.0863L7.53608 13.1363C7.24907 12.7781 7.06846 12.3465 7.01483 11.8907C6.9612 11.4348 7.0367 10.973 7.23274 10.558C7.39174 10.1973 7.65119 9.88999 7.98013 9.67277C8.30907 9.45554 8.69358 9.3376 9.08774 9.33301H18.9111C19.3052 9.3376 19.6898 9.45554 20.0187 9.67277C20.3476 9.88999 20.6071 10.1973 20.7661 10.558C20.9621 10.973 21.0376 11.4348 20.984 11.8907C20.9304 12.3465 20.7498 12.7781 20.4627 13.1363L15.5511 19.0863C15.3641 19.3182 15.1278 19.5054 14.8594 19.6346C14.591 19.7637 14.2972 19.8315 13.9994 19.833Z",
    fill: "#292B30"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDown);
export default __webpack_public_path__ + "static/media/icon-arrow-down.f15b95075a0e32a4793ea30b63da797d.svg";
export { ForwardRef as ReactComponent };